'use strict';
var parent = require('../../actual/instance/fill');

module.exports = parent;
